import { CopyField as BaseCopyField } from '@repo/ui';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';

const CopyField = ({ value, name }: { value: string; name: string }) => {
  const { trackEvent } = useAnalytics();

  const handleCopy = (value: string, name: string) => {
    trackEvent('Clicked Button', {
      text: `Copy ${name}`,
      href: '',
      variety: 'Button',
    });
  };

  return <BaseCopyField value={value} name={name} onCopy={handleCopy} />;
};

export default CopyField;
